<template>
  <div
    v-if="items.length"
    class="pt-5 pt-md-7 pt-lg-9 pb-10 pb-md-13 pb-lg-16 position-relative items"
  >
    <TitleWidget dark>
      <div>
        <small class="d-block font-weight-regular">Nossos</small>
        Produtos <small class="font-weight-regular">e</small> Serviços
      </div>
    </TitleWidget>

    <CarouselWidget
      class="mt-8 products-carousel-widget"
      :gap="0"
      :items="items"
      v-bind="carouselSettings"
    >
      <template #item="{ item, index }">
        <ProductCard
          :class="[index % 2 !== 0 ? 'mt-6 mt-sm-10 mt-md-16' : '']"
          v-bind="item"
        />
      </template>
    </CarouselWidget>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import ProductCard from "../cards/ProductCard.vue";
import { formatToURL } from "../../utils/formatToURL";

const _carouselSettings = {
  itemsToShow: {
    xs: 1.5,
    sm: 2.5,
    md: 3.4,
    lg: 5,
    xl: 5,
  },
  infiniteScroll: false,
  nav: true,
};

const _config = {
  mod: "products",
  path: "/produtos-e-servicos",
};

const _data = {
  carouselSettings: _carouselSettings,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img_home, title, introduction, text }) => ({
          img_home,
          title,
          introduction,
          text,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    CarouselWidget,
    ProductCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  background: rgb(255, 255, 255);
  background: -moz-linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(0, 94, 58, 1) 100%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(0, 94, 58, 1) 100%
  );
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(0, 94, 58, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#ffffff",endColorstr="#005e3a",GradientType=1);
}

.products-carousel-widget::v-deep {
  .carousel-widget-nav {
    bottom: -10px;
    justify-content: flex-end !important;
    left: 12px !important;
    right: 12px !important;
    top: auto;

    .carousel-widget-nav-item-prev,
    .carousel-widget-nav-item-next {
      background-color: transparent !important;

      .v-icon {
        color: var(--v-primary-base) !important;
      }
    }
  }
}
</style>
